import { createContext, PropsWithChildren, useContext } from "react";

export type navigationDirection = "forwards" | "backwards" | null;
export type titlePathMapping = { path: string; title: string };
interface BottomSheetContextProps {
  path: string;
  onPathChange: (value: string) => void;

  previousPath: string;
  onPreviousPathChange: (value?: string) => void;

  onTitlePathMappingChange: (value: titlePathMapping) => void;
  onRootPathChange: (value: string) => void;
  lastNavigationDirection: navigationDirection;
}

const BottomSheetContext = createContext<BottomSheetContextProps | undefined>(
  undefined,
);

export const BottomSheetProvider = ({
  children,
  ...rest
}: PropsWithChildren<BottomSheetContextProps>) => {
  return (
    <BottomSheetContext.Provider
      value={{
        ...rest,
      }}
    >
      {children}
    </BottomSheetContext.Provider>
  );
};

export function useBottomSheet() {
  const context = useContext(BottomSheetContext);
  if (context === undefined) {
    throw Error("useBottomSheet must be used within <BottomSheet/>");
  }
  return context;
}
